// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xUi7","right":"styles_right__2nezy"};